<script lang="ts">
	import AlgoliaResults from "@components/AlgoliaResults.svelte";
	import type { ActionReturn } from "svelte/action";
	import Input from "./form/Input.svelte";

	let {
		open = $bindable(false),
		searchText = $bindable(""),
		// eslint-disable-next-line prefer-const
		resultsWidth,
	}: { open?: boolean; searchText?: string; resultsWidth: "searchbar" | "overflow" } = $props();

	function outsideClick(div: HTMLDivElement): ActionReturn {
		function handleClick(event: MouseEvent): void {
			if (!div.contains(event.target as Node)) {
				open = false;
			}
		}
		document.addEventListener("click", handleClick);
		return {
			destroy(): void {
				document.removeEventListener("click", handleClick);
			},
		};
	}
</script>

<div use:outsideClick class="relative">
	<Input
		class="!border-lightblue !border-2 !rounded-full !py-2 !text-sm !min-h-[2.375rem]"
		value={searchText}
		oninput={(event) => {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
			searchText = event.currentTarget.value;
		}}
		type="search"
		placeholder="Vyhledejte produkt"
		onfocus={(): void => {
			open = true;
		}}
	/>

	{#if open}
		<div
			class={[
				"absolute top-full z-50",
				{ searchbar: "inset-x-0", overflow: "min-w-full max-w-96 right-0" }[resultsWidth],
			]}
		>
			<div class="overflow-auto max-h-96 bg-white rounded-xl mt-6 shadow-lg">
				<AlgoliaResults {searchText} />
			</div>
		</div>
	{/if}
</div>
